import Common from "./common.js";
import "../../scss/v5/trailer.scss";
import YouTubeHoverPreview from "./components/YouTubeHoverPreview.js";
import VideoFacade from "./components/VideoFacade.js";
import ScrollInView from "./components/ScrollInView.js";
import WatchlistToggle from "./components/WatchlistToggle.js";
import JustWatchButton from "./components/JustWatchButton.js";

Common.initPage(async (consentPromise) => {
  WatchlistToggle(document.querySelector(".add-to-watchlist-button")).mount();

  ScrollInView({
    observables: document.querySelectorAll(".related-videos.loading"),
    unobserveOnEnter: true,
    onEnter: (element) => {
      element.classList.remove("loading");
    },
  }).mount();

  // Initialize YouTube hover previews
  document.querySelectorAll(".trailer-list li[data-youtube-id]").forEach((item) => {
    YouTubeHoverPreview(item).mount();
  });

  // Initialize video facades (click-to-load for iframes)
  document.querySelectorAll(".video-facade").forEach((facade) => {
    VideoFacade(facade, consentPromise).mount();
  });

  const movieId = document.querySelector("h3.movie-title").id.split("-")[1];

  JustWatchButton({
    movieId,
    streamingButton: document.querySelector(".button.streaming"),
  }).mount();
});
